<template>
  <div class="review">
    <h1>
      {{ $t('review.heading') }}
      <span v-if="review.firstName">{{ review.firstName }}!</span>
      <span v-else-if="review.lastName">{{ review.lastName }}!</span>
    </h1>
    <p>
      {{ $t('review.msg') }} <b>{{ review.businessName }}</b
      >.
    </p>
    <div class="feedback-links clearfix">
      <div class="feedback-link">
        <a :href="review.gmbLink">
          <img :alt="$t('review.great')" src="../assets/img/smile-great.svg" />
          <span>{{ $t('review.great') }}</span>
        </a>
      </div>
      <div class="feedback-link">
        <router-link to="/feedback-form">
          <img :alt="$t('review.okay')" src="../assets/img/smile-okay.svg" />
          <span>{{ $t('review.okay') }}</span>
        </router-link>
      </div>
      <div class="feedback-link">
        <router-link to="/feedback-form">
          <img :alt="$t('review.notGood')" src="../assets/img/smile-not-good.svg" />
          <span>{{ $t('review.notGood') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Review',
  computed: mapState({
    review: state => state.review,
    feedbackSubmitted: state => state.feedbackSubmitted,
  }),
  created() {
    if (this.feedbackSubmitted) {
      this.$router.push('/feedback-submitted').catch(() => {});
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
.feedback-links {
  margin: 40px -5px;
  .feedback-link {
    float: left;
    padding: 0 5px;
    width: 33.3333%;
    a {
      display: block;
      color: $primary-dark-text;
      font-weight: bold;
      border-radius: 6px;
      border: 0.5px solid $secondary-dark-grey;
      box-shadow: 0 2px 4px 0 rgba(2, 0, 0, 0.06);
      padding: 20px 5px;
      img {
        margin: 0 auto 5px;
        display: block;
        width: 30px;
      }
      &:hover,
      &:focus {
        background: $primary-light-background;
        text-decoration: none;
      }
    }
  }
  @media (min-width: 550px) {
    margin: 50px 35px;
    .feedback-link {
      padding: 0 10px;
    }
  }
}
</style>
